import { Link } from "react-router-dom";
import { FaSignOutAlt } from "react-icons/fa";
import placeholder from "../../assets/placeholder.png";

const JoinedCommunityCard = ({ community, onLeave, isLeaving }) => {

  return (
    <div className="mb-5 bg-white w-full border shadow-2xl shadow-[#f2f5fc] rounded-md overflow-hidden">
      {/* Fixed Height Image Container */}
      <div className="w-full h-32 overflow-hidden">
        <img 
          className="w-full h-full object-cover" 
          src={community.banner || placeholder} 
          alt={community.name}
          loading="lazy" 
        />
      </div>
      
      {/* Content Section */}
      <div className="p-4 flex flex-col flex-grow">
        <div className="flex items-start justify-between mb-2">
          <Link to={`/skills-communities/${community.name}`} className="flex flex-col flex-1 cursor-pointer">
            <h3 className="text-lg font-semibold mb-2 text-gray-800 font-roboto-flex hover:text-primary transition-colors">{community.name}</h3>
            <p className="text-gray-600 font-roboto-flex text-sm">{community.members.length} members</p>
          </Link>
          
          {/* Leave Button */}
          {onLeave && (
            <button
              onClick={() => onLeave(community.name)}
              disabled={isLeaving}
              className="ml-4 bg-action hover:bg-action-hover text-white px-3 py-2 rounded-lg text-sm font-medium transition-colors font-roboto-flex disabled:opacity-50 flex items-center gap-2 whitespace-nowrap"
            >
              <FaSignOutAlt />
              {isLeaving ? "Leaving..." : "Leave"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default JoinedCommunityCard;
